/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, ContractFactory, Interface, } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "address[]",
                name: "_modules",
                type: "address[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "module",
                type: "address",
            },
        ],
        name: "AlreadyDisabledModule",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "module",
                type: "address",
            },
        ],
        name: "AlreadyEnabledModule",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "module",
                type: "address",
            },
        ],
        name: "InvalidModule",
        type: "error",
    },
    {
        inputs: [],
        name: "SetupModulesAlreadyCalled",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "module",
                type: "address",
            },
        ],
        name: "DisabledModule",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "module",
                type: "address",
            },
        ],
        name: "EnabledModule",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "module",
                type: "address",
            },
        ],
        name: "ExecutionFromModuleFailure",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "module",
                type: "address",
            },
        ],
        name: "ExecutionFromModuleSuccess",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "prevModule",
                type: "address",
            },
            {
                internalType: "address",
                name: "module",
                type: "address",
            },
        ],
        name: "disableModule",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "module",
                type: "address",
            },
        ],
        name: "enableModule",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "entryPoint",
        outputs: [
            {
                internalType: "contract IEntryPoint",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
            {
                internalType: "enum Enum.Operation",
                name: "operation",
                type: "uint8",
            },
        ],
        name: "execTransactionFromModule",
        outputs: [
            {
                internalType: "bool",
                name: "success",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
            {
                internalType: "enum Enum.Operation",
                name: "operation",
                type: "uint8",
            },
        ],
        name: "execTransactionFromModuleReturnData",
        outputs: [
            {
                internalType: "bool",
                name: "success",
                type: "bool",
            },
            {
                internalType: "bytes",
                name: "returnData",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
            {
                internalType: "enum Enum.Operation",
                name: "operation",
                type: "uint8",
            },
        ],
        name: "execute",
        outputs: [
            {
                internalType: "bytes",
                name: "returnData",
                type: "bytes",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
            {
                internalType: "enum Enum.Operation",
                name: "operation",
                type: "uint8",
            },
            {
                internalType: "uint256",
                name: "txGas",
                type: "uint256",
            },
        ],
        name: "execute",
        outputs: [
            {
                internalType: "bytes",
                name: "returnData",
                type: "bytes",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "start",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "pageSize",
                type: "uint256",
            },
        ],
        name: "getModulesPaginated",
        outputs: [
            {
                internalType: "address[]",
                name: "array",
                type: "address[]",
            },
            {
                internalType: "address",
                name: "next",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getNonce",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_module",
                type: "address",
            },
        ],
        name: "isModuleEnabled",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "signer",
                type: "address",
            },
        ],
        name: "isOperator",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "hash",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "signature",
                type: "bytes",
            },
        ],
        name: "isValidSignature",
        outputs: [
            {
                internalType: "bytes4",
                name: "magicValue",
                type: "bytes4",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256[]",
                name: "",
                type: "uint256[]",
            },
            {
                internalType: "uint256[]",
                name: "",
                type: "uint256[]",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "onERC1155BatchReceived",
        outputs: [
            {
                internalType: "bytes4",
                name: "",
                type: "bytes4",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "onERC1155Received",
        outputs: [
            {
                internalType: "bytes4",
                name: "",
                type: "bytes4",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "onERC721Received",
        outputs: [
            {
                internalType: "bytes4",
                name: "",
                type: "bytes4",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "initParams",
                type: "bytes",
            },
        ],
        name: "setUp",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "tokensReceived",
        outputs: [],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "sender",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "nonce",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes",
                        name: "initCode",
                        type: "bytes",
                    },
                    {
                        internalType: "bytes",
                        name: "callData",
                        type: "bytes",
                    },
                    {
                        internalType: "uint256",
                        name: "callGasLimit",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "verificationGasLimit",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "preVerificationGas",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "maxFeePerGas",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "maxPriorityFeePerGas",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes",
                        name: "paymasterAndData",
                        type: "bytes",
                    },
                    {
                        internalType: "bytes",
                        name: "signature",
                        type: "bytes",
                    },
                ],
                internalType: "struct UserOperation",
                name: "userOp",
                type: "tuple",
            },
            {
                internalType: "bytes32",
                name: "userOpHash",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "missingAccountFunds",
                type: "uint256",
            },
        ],
        name: "validateUserOp",
        outputs: [
            {
                internalType: "uint256",
                name: "validationData",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class ZodiacMech__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(_modules, overrides) {
        return super.getDeployTransaction(_modules, overrides || {});
    }
    deploy(_modules, overrides) {
        return super.deploy(_modules, overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new Interface(_abi);
    }
    static connect(address, runner) {
        return new Contract(address, _abi, runner);
    }
}
ZodiacMech__factory.bytecode = _bytecode;
ZodiacMech__factory.abi = _abi;
